import React, { useCallback, useMemo } from 'react';
import { useSubscriptions } from '@features/subscriptions/context/subscription-context';
import { Alert, FlexView, Text } from '@goodfynd/ui';
import { pluralize } from '@utils/string-util';

import { SubscriptionCheckoutItem } from './SubscriptionCheckoutItem';

import classes from './SubscriptionsCheckout.module.css';

export function SubscriptionCheckoutItemList() {
  const { cart } = useSubscriptions();

  const renderItems = useCallback(() => {
    if (!cart.items[0]) {
      return (
        <Alert className={classes['no-items']} status="neutral">
          No items in cart
        </Alert>
      );
    }

    return (
      <div className={classes['item-list']}>
        {cart.items.map((item) => (
          <SubscriptionCheckoutItem item={item} key={item.sku} />
        ))}
      </div>
    );
  }, [cart.items]);

  const totalItems = useMemo(() => {
    return cart.items.reduce((acc, item) => acc + item.newQuantity, 0);
  }, [cart.items]);

  return (
    <FlexView direction="column" gap={16} width="100%" wrap="nowrap">
      <div>
        <Text as="modalHeader">Cart</Text>
        <Text as="body2">
          {totalItems} {pluralize('item', totalItems)}
        </Text>
      </div>

      {renderItems()}
    </FlexView>
  );
}
